"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.DataAccessorSchema = exports.AthenaDataAccessorSchema = exports.AthenaAccessorConfigSchema = exports.AccessorTypeSchema = exports.AccessorTypeIterable = exports.SchemaItemSchema = exports.SchemaItemTypeSchema = exports.SchemaItemTypeIterable = void 0;
const zod_1 = require("zod");
// *** SCHEMA ***
exports.SchemaItemTypeIterable = ['string', 'number', 'boolean'];
exports.SchemaItemTypeSchema = zod_1.z.enum(exports.SchemaItemTypeIterable);
exports.SchemaItemSchema = zod_1.z.object({
    columnName: zod_1.z.string(),
    type: exports.SchemaItemTypeSchema,
});
// *** DATA ACCESSOR ***
exports.AccessorTypeIterable = ['athena'];
exports.AccessorTypeSchema = zod_1.z.enum(exports.AccessorTypeIterable);
exports.AthenaAccessorConfigSchema = zod_1.z.object({
    queryString: zod_1.z.string(),
});
exports.AthenaDataAccessorSchema = zod_1.z.object({
    name: zod_1.z.string(),
    type: zod_1.z.literal('athena'),
    config: exports.AthenaAccessorConfigSchema,
});
exports.DataAccessorSchema = exports.AthenaDataAccessorSchema;
exports.ConfigSchema = zod_1.z.object({
    schema: zod_1.z.array(exports.SchemaItemSchema),
    /**
     * Setting this as an array for future use cases where we may want to support
     * aggregating multiple data sources (e.g., other PG data) and potentially
     * applying some business logic to them (JOIN, SUM, etc.). This array will be
     * evaluated sequentially to determine how data is queried and transformed
     */
    dataAccessors: zod_1.z.array(exports.DataAccessorSchema),
});
//# sourceMappingURL=DataConfig.js.map